import { Col, Row, Text } from '@qonsoll/react-design'

import PropTypes from 'prop-types'
import { TechnologySimpleView } from 'domains/Technology/components'
import { useState } from 'react'
import { useTranslations } from 'contexts/Translation'

const TechnologyList = (props) => {
  const { technologies, isListWithCreate, listView, emptyProps, actions } =
    props

  // [COMPONENT_STATE_HOOKS]
  const [selectedItem, setSelectedItem] = useState(null)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const onEmptySpaceClick = () => setSelectedItem(null)

  return (
    <Row onClick={onEmptySpaceClick} mx={-3}>
      {technologies?.length > 0 ? (
        technologies?.map((technology, index) => (
          <Col
            mb={4}
            key={technology?._id || index}
            cw={listView ? 12 : [12, 6, 4]}>
            <TechnologySimpleView
              actions={actions}
              index={index}
              isSelected={technology?._id === selectedItem}
              onSelect={setSelectedItem}
              technology={technology}
            />
          </Col>
        ))
      ) : (
        <Col cw={isListWithCreate ? 'auto' : 12}>
          <Text variant="overline" type="secondary">
            {emptyProps?.message || t('No technologies have been created yet')}
          </Text>
        </Col>
      )}
    </Row>
  )
}

TechnologyList.propTypes = {
  technologies: PropTypes.array,
  isListWithCreate: PropTypes.bool,
  listView: PropTypes.bool,
  emptyProps: PropTypes.object,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default TechnologyList
